var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDbSelect(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 129,
    viewBox: "0 0 129 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_94_1971)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_94_1971",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35.2998,
    y: 32.3193,
    width: 10.8595,
    height: 31.027,
    rx: 0.7
  })), /*#__PURE__*/React.createElement("rect", {
    x: 35.2998,
    y: 32.3193,
    width: 10.8595,
    height: 31.027,
    rx: 0.7,
    stroke: "#5D38E5",
    strokeWidth: 5.6,
    strokeLinejoin: "round",
    mask: "url(#path-1-inside-1_94_1971)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_94_1971",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.2432,
    y: 32.3193,
    width: 10.8595,
    height: 31.027,
    rx: 0.7
  })), /*#__PURE__*/React.createElement("rect", {
    x: 56.2432,
    y: 32.3193,
    width: 10.8595,
    height: 31.027,
    rx: 0.7,
    stroke: "#5D38E5",
    strokeWidth: 5.6,
    strokeLinejoin: "round",
    mask: "url(#path-2-inside-2_94_1971)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3_94_1971",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.0229,
    y: 32.3193,
    width: 10.8595,
    height: 31.027,
    rx: 0.7
  })), /*#__PURE__*/React.createElement("rect", {
    x: 76.0229,
    y: 32.3193,
    width: 10.8595,
    height: 31.027,
    rx: 0.7,
    stroke: "#5D38E5",
    strokeWidth: 5.6,
    strokeLinejoin: "round",
    mask: "url(#path-3-inside-3_94_1971)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9771 33.8701V61.7944",
    stroke: "#5D38E5",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7568 33.8711V61.7954",
    stroke: "#5D38E5",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7827 33.8711V61.7954",
    stroke: "#5D38E5",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.8987,
    cy: 64.6985,
    r: 11.3986,
    fill: "white",
    stroke: "#5D38E5",
    strokeWidth: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6001 75.0005L90.5812 89.7383",
    stroke: "#5D38E5",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_94_1971",
    x: 0.299805,
    y: 0.119336,
    width: 127.883,
    height: 128.819,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.364706 0 0 0 0 0.219608 0 0 0 0 0.898039 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_94_1971"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_94_1971",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDbSelect);
export default __webpack_public_path__ + "static/media/icon_db_select.dd8daa86a7e8d3c82a231e79ea4840c2.svg";
export { ForwardRef as ReactComponent };